import type { Doc } from "building-types/doc";
import type { DocEntityTypeToValueType } from "building-types/entities/docEntityTypeToValueType";
import { docEntityTypeToDocTableName } from "./docEntityTypeToDocTableName";
import type { TableBasedDocEntityType, TableBasedDocEntityHandle } from "./tableBasedDocEntityHandle";

/**
 * This is the typical way to look up an entity in the Doc with type safety. There are exceptions
 * to this like `docGetShape`. Shapes are not stored in a table so you'll need to use that specific
 * function.
 */

export function docGetTableEntity<T extends TableBasedDocEntityType>(
  doc: Doc | null | undefined,
  handle: TableBasedDocEntityHandle<T>,
): DocEntityTypeToValueType[T] | null {
  if (!doc || !handle) {
    return null;
  }

  const docTableName = docEntityTypeToDocTableName[handle.type];

  if (!docTableName) {
    return null;
  }

  if (!doc[docTableName]) {
    return null;
  }

  return doc[docTableName][handle.id] as DocEntityTypeToValueType[T];
}
